import React, { useState, useEffect } from "react";
import { useRecoilState } from "recoil";
import axios from "axios";
import { useCookies } from "react-cookie";
import { userStateAtom } from "../atoms/userStateAtom";

interface ParsedData {
  name: string;
  certification: string;
  grade: string;
  userIdphp?: string;
}

const parseData = (data: string): ParsedData => {
  const parts = data.split("|");
  return {
    name: parts[0],
    certification: parts[1],
    grade: parts[7],
  };
};

const Login = () => {
  const [id, setId] = useState("");
  const [pw, setPw] = useState("");
  const [userState, setUserState] = useRecoilState<any>(userStateAtom);
  const [rememberId, setRememberId] = useState(false);
  const [rememberPw, setRememberPw] = useState(false);

  useEffect(() => {
    const rememberedId = localStorage.getItem("rememberedId");
    const rememberedPw = localStorage.getItem("rememberedPw");

    if (rememberedId) setId(rememberedId);
    if (rememberedPw) setPw(rememberedPw);
  }, []);

  const onLogin = async (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    const usedCheck = await axios.get(
      `https://chamstudyland.com/api/fun_learning/check_usedId.php?id=${id}`
    );
    if (id.includes("kms")) {
      if (usedCheck.data === 1) {
        alert("사용된 아이디입니다.");
        return;
      } else {
        await axios.post(
          "https://chamstudyland.com/api/fun_learning/post_usedId.php",
          {
            id: id,
          },
          {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          }
        );
      }
    }

    try {
      const response = await axios.get(
        `https://chamstudyland.com/cham_admin/cham_login_check.php?id=${id}&pass=${pw}`
      );
      console.log(response);
      const data = response.data;
      console.log(data);

      if (response.status === 200) {
        if (data === "<") {
          alert("아이디와 비밀번호를 다시 확인해주세요.");
        } else {
          let parsedData: ParsedData = parseData(data);
          parsedData.userIdphp = id;
          console.log("이거 파싱된거", parsedData);
          if (parsedData.certification !== "0") {
            alert("비인증 회원입니다.");
          } else {
            setUserState({ isLoggedIn: true, userData: parsedData });
            if (rememberId) localStorage.setItem("rememberedId", id);
            if (rememberPw) localStorage.setItem("rememberedPw", pw);
          }
        }
      } else if (data.status === "500") {
        alert("아이디와 비밀번호를 다시 확인해주세요.");
      }
    } catch (error) {
      console.error("로그인 중 에러 발생:", error);
    }
  };

  const onIdChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setId(e.target.value);
  };

  const onPwChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setPw(e.target.value);
  };

  const onRememberIdChange = () => {
    setRememberId(!rememberId);
  };

  const onRememberPwChange = () => {
    setRememberPw(!rememberPw);
  };
  return (
    <div className="bg-gray-200 h-screen flex justify-center items-center dark:bg-gray-600">
      <div className="bg-white p-8 rounded-lg shadow-lg w-96 dark:bg-slate-800">
        <h1 className="text-3xl font-semibold mb-4 text-center dark:text-white">
          Login
        </h1>
        <form onSubmit={onLogin}>
          <div className="mb-4">
            <input
              type="text"
              placeholder="Username"
              className="w-full border-gray-300 border px-4 py-2 rounded-md focus:outline-none focus:border-blue-400 dark:bg-slate-500"
              value={id}
              onChange={onIdChange}
            />
          </div>
          <div className="mb-4">
            <input
              type="password"
              placeholder="Password"
              className="w-full border-gray-300 border px-4 py-2 rounded-md focus:outline-none focus:border-blue-400 dark:bg-slate-500"
              value={pw}
              onChange={onPwChange}
            />
          </div>
          <div className="mb-4 flex items-center justify-between">
            <label className="dark:text-slate-300">
              <input
                type="checkbox"
                checked={rememberId}
                onChange={onRememberIdChange}
              />{" "}
              Remember id
            </label>
            <label className="dark:text-slate-300">
              <input
                type="checkbox"
                checked={rememberPw}
                onChange={onRememberPwChange}
              />{" "}
              Remember pw
            </label>
          </div>
          <button
            type="submit"
            className="w-full bg-blue-500 dark:bg-blue-800 text-white py-2 px-4 rounded-md hover:bg-blue-600 focus:outline-none focus:bg-blue-600"
          >
            Login
          </button>
        </form>
      </div>
    </div>
  );
};

export default Login;
